import { type ComponentProps, type ReactNode, useId } from "react";
import { cx, styles as s } from "./ui";

/** 入力欄（ラベル・入力例・エラーを読み上げにも結びつける） */
export function Field({ label, hint, error, big, ...input }: ComponentProps<"input"> & { label: string; hint?: ReactNode; error?: string | null; big?: boolean }) {
  const id = useId();
  const hintId = hint ? `${id}-hint` : undefined;
  const errId = error ? `${id}-err` : undefined;
  return (
    <div className={s.field}>
      <label htmlFor={id} className={s.label}>{label}</label>
      <input id={id} {...input} className={cx(s.input, big && s.codeInput)} aria-invalid={error ? true : undefined} aria-describedby={[hintId, errId].filter(Boolean).join(" ") || undefined} />
      {hint && <p id={hintId} className={s.hint}>{hint}</p>}
      {error && <p id={errId} className={s.fieldError}>{error}</p>}
    </div>
  );
}

export function Checkbox({ label, ...input }: ComponentProps<"input"> & { label: ReactNode }) {
  return (
    <label className={s.choice}>
      <input type="checkbox" {...input} />
      <span>{label}</span>
    </label>
  );
}

export function Radio({ label, ...input }: ComponentProps<"input"> & { label: ReactNode }) {
  return (
    <label className={s.choice}>
      <input type="radio" {...input} />
      <span>{label}</span>
    </label>
  );
}

export function Choices({ legend, children }: { legend: string; children: ReactNode }) {
  return (
    <fieldset className={s.choices}>
      <legend>{legend}</legend>
      {children}
    </fieldset>
  );
}
